// Loader.js
import React from "react";
import "./Loader.css";
import Navbar from "./navigationbar/Navbar";
import Footer from "./Footer/Footer";

const Loader = () => {
  return (<>
    
    <div className="loader-overlay">
      <div className="loader"></div>
    </div>
    
    </>
  );
};

export default Loader;
